import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
@Component({
  selector: 'app-service-category',
  templateUrl: './service-category.component.html',
  styleUrls: ['./service-category.component.scss']
})
export class ServiceCategoryComponent implements OnInit, OnDestroy {
  categories: any[] = [];
  vendorCounts: { [key: string]: number } = {};
  loading: boolean = true;
  unreadEnquiriesCount: number = 0;
  private pollInterval: any;
  
  // Slideshow State
  activeAds: any[] = [];
  currentAdIndex: number = 0;
  private adSlideshowTimer: any;
  
  // Custom Dropdown State
  isCategoryOpen: boolean = false;
  isCityOpen: boolean = false;
  selectedCategoryId: string = '';
  selectedCategoryName: string = 'All Categories';
  selectedCity: string = 'All Categories';
  cities: any[] = [];
filteredCities: any[] = [];
searchCity: string = '';

  // cities: string[] = [
  //   'Ariyalur', 'Chengalpattu', 'Chennai', 'Coimbatore', 'Cuddalore', 'Dharmapuri', 
  //   'Dindigul', 'Erode', 'Kallakurichi', 'Kanchipuram', 'Kanyakumari', 'Karur', 
  //   'Krishnagiri', 'Madurai', 'Mayiladuthurai', 'Nagapattinam', 'Namakkal', 'Nilgiris', 
  //   'Perambalur', 'Pudukkottai', 'Ramanathapuram', 'Ranipet', 'Salem', 'Sivaganga', 
  //   'Tenkasi', 'Thanjavur', 'Theni', 'Thoothukudi', 'Tiruchirappalli', 'Tirunelveli', 
  //   'Tirupathur', 'Tiruppur', 'Tiruvallur', 'Tiruvannamalai', 'Tiruvarur', 'Vellore', 
  //   'Villupuram', 'Virudhunagar'
  // ];
  
  // Static Hero
  heroImage = 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80';
  heroTitle = "Discover Premium Wedding Vendors";
  heroSubtitle = "Book trusted professionals for your special day.";

  premiumVendors: any[] = [];
allPremiumVendors: any[] = [];

showAllPremiumModal: boolean = false;
  
  weddingPackages = [
    { title: 'Budget Wedding', description: 'Essential services for a beautiful day', icon: 'payments' },
    { title: 'Classic Wedding', description: 'Photography + Makeup + Decor', icon: 'favorite' },
    { title: 'Premium Wedding', description: 'Complete Wedding Package', icon: 'diamond' },
    { title: 'Luxury Wedding', description: 'All-inclusive premium experience', icon: 'star' },
    { title: 'Destination Wedding', description: 'Travel, Stay & Planning', icon: 'flight_takeoff' }
  ];

  whyWeddingly = [
    { title: 'Verified Vendors', description: 'Handpicked and trusted professionals.', icon: 'verified_user' },
    { title: 'Secure Booking', description: '100% safe and secure transactions.', icon: 'security' },
    { title: 'Trusted Reviews', description: 'Real reviews from genuine couples.', icon: 'reviews' },
    { title: 'Fast Support', description: '24/7 dedicated customer assistance.', icon: 'support_agent' }
  ];

  testimonials = [
    { name: 'Priya & Rahul', review: 'Found the perfect photographer for our wedding! Highly recommended.', rating: 5 },
    { name: 'Ananya & Vikram', review: 'The booking process was so smooth and the vendors were very professional.', rating: 5 },
    { name: 'Sneha & Arjun', review: 'Weddingly made planning our destination wedding a breeze.', rating: 4 }
  ];

  faqs = [
    { question: 'How do I book a vendor?', answer: 'Simply browse our categories, view vendor profiles, and click Book Now to send an enquiry or confirm a date.', open: false },
    { question: 'Are the reviews genuine?', answer: 'Yes, all reviews are from verified couples who have booked through our platform.', open: false },
    { question: 'Can I cancel a booking?', answer: 'Cancellations depend on the individual vendor policies displayed on their profile.', open: false }
  ];

  filters = ['Category', 'Location', 'Budget', 'Rating', 'Availability', 'Sort'];

  constructor(
    private router: Router,
    private apiService: ApiServiceService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.getCategories();
     this.getCategoryVendorCounts();
    this.getActiveAds();
    this.getPremiumVendors();
     this.getMerchantCities();
    this.fetchUnreadEnquiries();
    this.pollInterval = setInterval(() => {
      this.fetchUnreadEnquiries();
    }, 10000);
  }
  goBack(): void {
  // this.location.back();
  this.router.navigate(['/dashboard']);
}

  ngOnDestroy(): void {
    if (this.pollInterval) clearInterval(this.pollInterval);
    if (this.adSlideshowTimer) clearInterval(this.adSlideshowTimer);
  }

  fetchUnreadEnquiries() {
    const profileId = localStorage.getItem('profileId');
    if (profileId) {
      this.apiService.getUserEnquiries(profileId).subscribe({
        next: (response: any) => {
          if (response && response.data) {
            this.unreadEnquiriesCount = response.data.reduce((acc: number, curr: any) => acc + (curr.user_unread_count || 0), 0);
          }
        },
        error: (error: any) => console.error('Error fetching unread enquiry count:', error)
      });
    }
  }

  getPremiumVendors() {
  this.apiService.getPremiumVendors().subscribe({
    next: (res: any) => {

      if (res.data) {

        const vendors = res.data.map((vendor: any) => ({
          name: vendor.business_name,
          badge: 'Premium',
          rating: vendor.rating || 5.0,
          reviews: vendor.totalReviews || 0,
          location: vendor.city || vendor.district || 'Location not available',
          category: vendor.category?.name || 'Wedding Vendor',

          image: vendor.profile_pic
            ? this.getProfilePicUrl(vendor)
            : 'assets/images/default-vendor.jpg',

          id: vendor._id
        }));

        // Keep all vendors
        this.allPremiumVendors = vendors;

        // Only show first 12 in homepage section
        this.premiumVendors = vendors.slice(0, 12);
      }
    },

    error: (err) => {
      console.error("Failed to load premium vendors", err);
    }
  });
}
openAllPremiumVendors() {
  this.showAllPremiumModal = true;
}

closeAllPremiumVendors() {
  this.showAllPremiumModal = false;
}
  getCategoryVendorCounts() {
  this.apiService.getCategoryVendorCounts().subscribe({
    next: (res: any) => {
      if (res && res.data) {
        this.vendorCounts = {};

        res.data.forEach((item: any) => {
          this.vendorCounts[item.categoryId] = item.count;
        });
      }
    },
    error: (err) => {
      console.error("Failed to load category vendor counts", err);
    }
  });
}


  getActiveAds() {
    this.apiService.getActiveAdvertisements().subscribe({
      next: (res: any) => {
        if (res.data && res.data.length > 0) {
          this.activeAds = res.data;
          this.startAdSlideshow();
        }
      },
      error: (err) => {
        console.error("Failed to load active advertisements", err);
      }
    });
  }

  startAdSlideshow() {
    if (this.activeAds.length > 1) {
      this.adSlideshowTimer = setInterval(() => {
        this.currentAdIndex = (this.currentAdIndex + 1) % this.activeAds.length;
      }, 4000);
    }
  }

  getAdBackground(ad: any) {
    if (ad.profile_pic) {
      const url = ad.profile_pic.startsWith('/') ? environment.apiUrl + ad.profile_pic : ad.profile_pic;
      return `linear-gradient(135deg, rgba(74, 21, 75, 0.9) 0%, rgba(26, 26, 46, 0.95) 100%), url('${url}')`;
    }
    return `linear-gradient(135deg, #4A154B 0%, #1A1A2E 100%)`;
  }

  getProfilePicUrl(ad: any) {
    if (ad.profile_pic) {
      return ad.profile_pic.startsWith('/') ? environment.apiUrl + ad.profile_pic : ad.profile_pic;
    }
    return 'assets/images/default-avatar.png'; // Fallback if no image
  }



  toggleFaq(index: number) {
    this.faqs[index].open = !this.faqs[index].open;
  }

  getCategories() {
    this.apiService.getServiceCategories().subscribe({
      next: (res: any) => {
        this.categories = res.data || [];
        // Map some default images to categories since existing API might only have icons
        this.categories = this.categories.map((c, i) => {
          const defaultImages = [
            'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=400&q=80', // Photography
            'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=400&q=80', // Venues
            'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?auto=format&fit=crop&w=400&q=80', // Makeup
            'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?auto=format&fit=crop&w=400&q=80', // Mehendi
            'https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&w=400&q=80'  // Planning
          ];
          return { ...c, image: defaultImages[i % defaultImages.length] };
        });
        this.loading = false;
      },
      error: (err) => {
        console.log("Category loading error", err);
        this.loading = false;
      }
    });
  }

  openCategory(category: any) {
    this.router.navigate(['/wedding-services', category._id]);
  }

  searchVendors() {
    if (this.selectedCategoryId) {
      const queryParams = this.selectedCity ? { city: this.selectedCity } : {};
      this.router.navigate(['/wedding-services', this.selectedCategoryId], { queryParams });
    } else {
      // If no category selected, maybe scroll to popular categories
      const el = document.querySelector('.popular-categories');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  toggleCategoryDropdown(e: Event) {
    e.stopPropagation();
    this.isCategoryOpen = !this.isCategoryOpen;
    this.isCityOpen = false;
  }

  // toggleCityDropdown(e: Event) {
  //   e.stopPropagation();
  //   this.isCityOpen = !this.isCityOpen;
  //   this.isCategoryOpen = false;
  // }

  selectCategory(id: string, name: string, event?: Event) {
    if (event) event.stopPropagation();
    this.selectedCategoryId = id;
    this.selectedCategoryName = name;
    this.isCategoryOpen = false;
  }
  toggleCityDropdown(e: Event): void {
  e.stopPropagation();

  this.isCityOpen = !this.isCityOpen;
  this.isCategoryOpen = false;

  if (this.isCityOpen) {
    this.searchCity = '';
  }
}

  // selectCity(city: string, event?: Event) {
  //   if (event) event.stopPropagation();
  //   this.selectedCity = city;
  //   this.isCityOpen = false;
  // }

  // Close dropdowns on outside click (handled via window listener in a real app, or simple blur)
  closeDropdowns() {
    this.isCategoryOpen = false;
    this.isCityOpen = false;
  }

  openBookingDetails() {
    this.router.navigate(['wedding-services/booking-details']);
  }

  openPaymentDetails() {
    this.router.navigate(['wedding-services/payment-details']);
  }

  openEnquiryDetails() {
    this.router.navigate(['/wedding-services/enquiries']);
  }

  goToMerchantProfile(merchantId: string) {
    if (merchantId) {
      this.router.navigate(['/wedding-services/merchant', merchantId]);
    }
  }
  getMerchantCities(): void {
  this.apiService.getMerchantCities().subscribe({
    next: (response: any) => {
      console.log('Merchant Cities Response:', response);

      this.cities = response.data || [];
      this.filteredCities = [...this.cities];

      // Keep Chennai selected if it exists
      const chennaiExists = this.cities.some(
        (city: any) =>
          city.city_nme?.toLowerCase() === 'chennai'
      );

      if (!chennaiExists && this.cities.length > 0) {
        this.selectedCity = this.cities[0].city_nme;
      }
    },

    error: (error) => {
      console.error(
        'Merchant Cities Fetch Error:',
        error
      );

      this.cities = [];
      this.filteredCities = [];
    }
  });
}

getFilteredCities(): any[] {
  const search = this.searchCity.toLowerCase().trim();

  if (!search) {
    return this.cities;
  }

  return this.cities.filter((city: any) =>
    city.city_nme
      ?.toLowerCase()
      .includes(search)
  );
}

selectCity(city: string, event?: Event): void {
  if (event) {
    event.stopPropagation();
  }

  this.selectedCity = city;
  this.searchCity = '';
  this.isCityOpen = false;
}

}